import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  getVisitedProducts,
  removeVisitedProduct,
} from "../services/visitedProductService";
import ProductCardNew from "../components/ProductCard/ProductCardNew";
import { ChevronDown } from "lucide-react";
import DashboardProductsSkeleton from "./Dashboard/Skeleton/Products/DashboardProductsSkeleton.jsx";

export default function DashboardVisitedProducts() {
  const { user } = useAuth();
  const [visibleCount, setVisibleCount] = useState(12);
  const [loading, setLoading] = useState(true);

  const [products, setProducts] = useState([]);

  useEffect(() => {
    getVisitedProducts().then((data) => {
      setProducts(data);
      setLoading(false);
    });
  }, []);

  const showMore = () => {
    setVisibleCount((prev) => prev + 12);
  };

  const visibleProducts = products.slice(0, visibleCount);

  const handleRemove = async (id) => {
    const success = await removeVisitedProduct(id);

    if (!success) return;

    setProducts((prev) => prev.filter((item) => item.id !== id));
  };

  // if (loading) {
  //   return (
  //     <div className="loader-wrapper">
  //       <div className="loading">
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //       </div>
  //     </div>
  //   );
  // }

  if (loading) {
    return <DashboardProductsSkeleton productCount={8} />;
  }

  return (
    <div className="wrapper">
      <h2>
        <span> بازدیدهای من</span>
      </h2>

      <div className="grid">
        {products.length === 0 ? (
          <p>No wishlist items found.</p>
        ) : (
          visibleProducts.map((p) => (
            <ProductCardNew
              key={p.id}
              product={p}
            // setSelectedProduct={setSelectedProduct}
            //  setShowVariationModal={setShowVariationModal}
            />
          ))
        )}
      </div>

      <div className="wrapper-footer">
        {products.length > visibleCount && (
          <button onClick={showMore} className="show-more-btn">
            نمایش بیشتر
            <ChevronDown color="#95b73c" />
            {/* Show More ({wishlist.length - visibleCount} left) */}
          </button>
        )}
      </div>
    </div>
  );
}
